export const logoList = [
  {
    id: 32,
    link: require("@/assets/logo/dentArtistry.svg")
  },
  {
    id: 34,
    link: require("@/assets/logo/hexaTees.svg")
  },
  {
    id: 35,
    link: require("@/assets/logo/medicare.svg")
  },
  {
    id: 36,
    link: require("@/assets/logo/MvEvents.svg")
  },
  {
    id: 37,
    link: require("@/assets/logo/innovativeCircuits.svg")
  },
  {
    id: 1,
    link: require("@/assets/logo/kkiokio.svg")
  },
  {
    id: 2,
    link: require("@/assets/logo/Weego.svg")
  },
  {
    id: 3,
    link: require("@/assets/logo/kkiokioBg.svg")
  },
  {
    id: 4,
    link: require("@/assets/logo/wanderSaneGlobe.svg")
  },
  {
    id: 5,
    link: require("@/assets/logo/wanderSaneBadge.svg")
  },
  {
    id: 6,
    link: require("@/assets/logo/wanderSaneHelmet.svg")
  },
  {
    id: 7,
    link: require("@/assets/logo/metered.svg")
  },
  {
    id: 8,
    link: require("@/assets/logo/prideSwag.svg")
  },
  {
    id: 9,
    link: require("@/assets/logo/learningTree.svg")
  },
  {
    id: 10,
    link: require("@/assets/logo/tentFire.svg")
  },
  {
    id: 11,
    link: require("@/assets/logo/tentPalace.svg")
  },
  {
    id: 12,
    link: require("@/assets/logo/mountain.svg")
  },
  {
    id: 13,
    link: require("@/assets/logo/beach.svg")
  },
  {
    id: 14,
    link: require("@/assets/logo/rider.svg")
  },
  {
    id: 15,
    link: require("@/assets/logo/wanderSaneStamp.svg")
  },
  {
    id: 16,
    link: require("@/assets/logo/natureStamp.svg")
  },
  // {
  //   id: 17,
  //   link: require("@/assets/logo/fireLog.svg")
  // },
  {
    id: 18,
    link: require("@/assets/logo/deer.svg")
  },
  {
    id: 19,
    link: require("@/assets/logo/bird.svg")
  },
  {
    id: 20,
    link: require("@/assets/logo/biceps.svg")
  },
  {
    id: 21,
    link: require("@/assets/logo/tent.svg")
  },
  // {
  //   id: 22,
  //   link: require("@/assets/logo/electron.svg")
  // },
  {
    id: 23,
    link: require("@/assets/logo/sandyGlobe.svg")
  },
  {
    id: 24,
    link: require("@/assets/logo/biker.svg")
  },
  {
    id: 25,
    link: require("@/assets/logo/hexa.svg")
  },
  {
    id: 26,
    link: require("@/assets/logo/wanderSaneVlogs.svg")
  },
  {
    id: 27,
    link: require("@/assets/logo/wonderWheel.svg")
  },
  {
    id: 28,
    link: require("@/assets/logo/electroWheel.svg")
  },
  {
    id: 29,
    link: require("@/assets/logo/wrenchWheel.svg")
  },
  {
    id: 30,
    link: require("@/assets/logo/unison.svg")
  },
  // {
  //   id: 31,
  //   link: require("@/assets/logo/Artboard 27.svg")
  // },
  {
    id: 33,
    link: require("@/assets/logo/anglePlus.svg")
  }
];
